document.addEventListener("DOMContentLoaded", function (event) {

    // ----------------------------------------------------------------
    // Info icon popups
    // ----------------------------------------------------------------
    function showInfoPopup(text) {
        var overlay = document.createElement('div');
        overlay.className = 'info-popup-overlay';

        var popup = document.createElement('div');
        popup.className = 'info-popup';
        popup.setAttribute('role', 'dialog');
        popup.setAttribute('aria-modal', 'true');

        var p = document.createElement('p');
        p.className = 'info-popup-text';
        p.textContent = text;

        var closeBtn = document.createElement('button');
        closeBtn.type = 'button';
        closeBtn.className = 'info-popup-close';
        closeBtn.textContent = 'Schließen';

        popup.appendChild(p);
        popup.appendChild(closeBtn);
        document.body.appendChild(overlay);
        document.body.appendChild(popup);
        closeBtn.focus();

        function close() {
            document.body.removeChild(overlay);
            document.body.removeChild(popup);
            document.removeEventListener('keydown', onEsc);
        }

        function onEsc(e) {
            if (e.key === 'Escape') close();
        }

        closeBtn.addEventListener('click', close);
        overlay.addEventListener('click', close);
        document.addEventListener('keydown', onEsc);
    }

    document.querySelectorAll('[data-info]').forEach(function (btn) {
        btn.addEventListener('click', function () {
            showInfoPopup(this.getAttribute('data-info'));
        });
    });

    // ----------------------------------------------------------------
    // Vacation table: add year row dynamically
    // ----------------------------------------------------------------
    const vacationAddBtn     = document.querySelector('[data-behaviour="vacation-add-year"]');
    const vacationAddPrevBtn = document.querySelector('[data-behaviour="vacation-add-prev-year"]');
    const vacationTbody      = document.querySelector('[data-vacation-table]');

    if (vacationAddBtn && vacationTbody) {
        vacationAddBtn.addEventListener('click', function () {
            const rows     = vacationTbody.querySelectorAll('tr');
            const lastRow  = rows[rows.length - 1];
            const lastYear = lastRow ? parseInt(lastRow.cells[0].textContent.trim(), 10) : new Date().getFullYear();
            const newYear  = (isNaN(lastYear) ? new Date().getFullYear() : lastYear) + 1;

            const tr = document.createElement('tr');
            tr.innerHTML =
                '<td>' + newYear + '</td>' +
                '<td><input type="number" name="VacationDays_' + newYear + '" value="" min="0" class="text"></td>' +
                '<td><input type="number" name="AzvDays_' + newYear + '" value="" min="0" class="text"></td>';
            vacationTbody.appendChild(tr);
        });
    }

    if (vacationAddPrevBtn && vacationTbody) {
        vacationAddPrevBtn.addEventListener('click', function () {
            const rows      = vacationTbody.querySelectorAll('tr');
            const firstRow  = rows[0];
            const firstYear = firstRow ? parseInt(firstRow.cells[0].textContent.trim(), 10) : new Date().getFullYear();
            const newYear   = (isNaN(firstYear) ? new Date().getFullYear() : firstYear) - 1;

            const tr = document.createElement('tr');
            tr.innerHTML =
                '<td>' + newYear + '</td>' +
                '<td><input type="number" name="VacationDays_' + newYear + '" value="" min="0" class="text"></td>' +
                '<td><input type="number" name="AzvDays_' + newYear + '" value="" min="0" class="text"></td>';
            vacationTbody.prepend(tr);
        });
    }

    // ----------------------------------------------------------------
    // Vacation period form: show DaysNextYear when dates span years
    // ----------------------------------------------------------------
    document.querySelectorAll('[data-vacation-start]').forEach(function (startInput) {
        const form = startInput.closest('form');
        if (!form) return;

        const endInput          = form.querySelector('[data-vacation-end]');
        const daysNextYearInput = form.querySelector('[data-days-next-year]');
        const daysInput         = form.querySelector('[data-days-label]');
        const daysLabel         = daysInput?.closest('.field')?.querySelector('label');

        if (!endInput || !daysNextYearInput) return;

        const daysNextYearHolder = daysNextYearInput.closest('.field');

        function update(overwrite) {
            const startYear = startInput.value ? parseInt(startInput.value.split('-')[0], 10) : null;
            const endYear   = endInput.value   ? parseInt(endInput.value.split('-')[0], 10)   : null;
            const spans     = startYear && endYear && startYear !== endYear;

            daysNextYearHolder.style.display = spans ? '' : 'none';
            daysNextYearInput.disabled       = !spans;
            if (!spans) daysNextYearInput.value = '';

            if (daysLabel) {
                daysLabel.textContent = spans ? ('Anzahl Tage ' + startYear + ':') : 'Anzahl Tage:';
            }
            const nextLabel = daysNextYearHolder.querySelector('label');
            if (nextLabel && endYear && spans) {
                nextLabel.textContent = 'Anzahl Tage ' + endYear + ':';
            }

            if (startInput.value && endInput.value && startInput.value <= endInput.value) {
                fetch('/courses/calcVacationDays?start=' + startInput.value + '&end=' + endInput.value)
                    .then(function (r) { return r.json(); })
                    .then(function (data) {
                        if (daysInput && data.days !== null && (overwrite || daysInput.value === '')) {
                            daysInput.value = data.days;
                        }
                        if (daysNextYearInput && data.daysNextYear !== null && (overwrite || daysNextYearInput.value === '')) {
                            daysNextYearInput.value = data.daysNextYear;
                        }
                    });
            }
        }

        startInput.addEventListener('change', function () { update(true); });
        endInput.addEventListener('change', function () { update(true); });
        update(false);
    });

    // ----------------------------------------------------------------
    // Vacation period override form: require note when days changed
    // ----------------------------------------------------------------
    const overrideForm = document.querySelector('[data-behaviour="vacation-override-form"]');
    if (overrideForm) {
        overrideForm.addEventListener('submit', function (e) {
            let hasError = false;
            overrideForm.querySelectorAll('input[data-original][data-note-ref]').forEach(function (daysInput) {
                const original      = parseInt(daysInput.getAttribute('data-original'), 10);
                const current       = parseInt(daysInput.value, 10) || 0;
                if (current !== original) {
                    const noteFieldName = daysInput.getAttribute('data-note-ref');
                    const noteInput     = overrideForm.querySelector('[name="' + noteFieldName + '"]');
                    if (noteInput && noteInput.value.trim() === '') {
                        noteInput.classList.add('input--error');
                        hasError = true;
                    }
                }
            });
            if (hasError) {
                e.preventDefault();
                const firstError = overrideForm.querySelector('.input--error');
                if (firstError) {
                    firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    firstError.focus();
                }
            }
        });

        overrideForm.querySelectorAll('.vacation-period-note').forEach(function (noteInput) {
            noteInput.addEventListener('input', function () {
                if (this.value.trim() !== '') {
                    this.classList.remove('input--error');
                }
            });
        });
    }

    // ----------------------------------------------------------------
    // Delete request modal
    // ----------------------------------------------------------------
    const deleteDialog = document.getElementById('delete-request-dialog');
    if (deleteDialog) {
        document.querySelectorAll('[data-behaviour="delete-request"]').forEach(function (btn) {
            btn.addEventListener('click', function () {
                document.getElementById('delete-request-id').value    = btn.getAttribute('data-request-id');
                document.getElementById('delete-request-back').value  = btn.getAttribute('data-back-url');
                document.getElementById('delete-request-reason').value = '';
                deleteDialog.showModal();
            });
        });

        document.getElementById('delete-request-cancel')?.addEventListener('click', function () {
            deleteDialog.close();
        });

        deleteDialog.addEventListener('click', function (e) {
            if (e.target === deleteDialog) {
                deleteDialog.close();
            }
        });
    }

const menu_button = document.querySelector('[data-behaviour="toggle-menu"]');

    if (menu_button) {
        menu_button.addEventListener('click', () => {
            document.body.classList.toggle('body--show');
        });
    }

    // ----------------------------------------------------------------
    // Absence request form: dynamic field visibility based on type
    // ----------------------------------------------------------------
    const typeSelect = document.querySelector('[data-request-type]');
    if (!typeSelect) return;

    const endDateHolder       = document.querySelector('[data-end-date]')?.closest('.field');
    const endDateLabel        = endDateHolder?.querySelector('label');
    const startDateLabel      = document.querySelector('[data-start-date]')?.closest('.field')?.querySelector('label');
    const officialReasonField = document.querySelector('[data-reason-field="Dienstbefreiung"]');
    const onlineReasonField   = document.querySelector('[data-reason-field="OnlineTeilnahme"]');
    const attachmentInput     = document.querySelector('[data-attachment]');
    const attachmentCol       = attachmentInput?.closest('.file-uploads-col');
    const attachmentLabel     = attachmentCol?.querySelector('.file-section-heading');
    const attachmentInfoBtn   = attachmentCol?.querySelector('.info-icon-btn');
    const attachment2Input    = document.querySelector('[data-attachment2]');
    const attachment2Col      = attachment2Input?.closest('.file-uploads-col');
    const noteInput           = document.querySelector('[data-note]');
    const noteLabel           = noteInput?.closest('.field')?.querySelector('label');
    const onlineInfoBlock        = document.getElementById('online-participation-info');
    const sickLeaveInfoBlock     = document.getElementById('sick-leave-info');
    const familyworkInfoBlock    = document.getElementById('familywork-info');
    const specialistInfoBlock    = document.getElementById('specialist-info');
    const noProctoredExamInput   = document.querySelector('[data-no-proctored-exam]');
    const noProctoredExamLabel   = noProctoredExamInput?.closest('.field')?.querySelector('label');
    const noProctoredExamDefault = 'Ich erkläre, dass ich innerhalb des Beantragungszeitraumes keine Prüfungs- und Studienleistungen zu erbringen habe*';
    const noProctoredExamSick    = 'Mir ist bekannt, dass ich im Falle einer zu erbringenden Prüfungs- und Studienleistungen im obigen Zeitraum eine Prüfungsunfähigkeitsbescheinigung meines Arztes vorlegen muss*';
    const attachmentHolder       = attachmentInput?.closest('.field');
    const sickAttachmentHint     = (() => {
        if (!attachmentHolder) return null;
        const p = document.createElement('p');
        p.className = 'form-hint form-hint--attachment-sick';
        p.style.display = 'none';
        p.textContent = 'Bitte laden Sie bei mehr als drei Tagen einen Nachweis hoch';
        attachmentHolder.appendChild(p);
        return p;
    })();

    function getHolder(field) {
        return field ? field.closest('.field') : null;
    }

    function setFieldVisible(holder, field, visible, required = false) {
        if (!holder) return;
        holder.style.display = visible ? '' : 'none';
        if (field) {
            // Disable hidden fields: excluded from browser validation and form submission
            field.disabled = !visible;
            field.required = visible && required;
            // Reset value when hiding field to prevent invalid values from being submitted
            if (!visible) {
                field.value = '';
            }
        }
    }

    function updateFields(type) {
        const isOnline    = type === 'OnlineTeilnahme';
        const isDienst    = type === 'Dienstbefreiung';
        const isSickLeave = type === 'Krankmeldung';

        if (noteInput) {
            noteInput.placeholder = isOnline
                ? 'Bitte den Antrag hier begründen. Teilen Sie uns auch den Zeitraum mit, falls der Antrag nicht ganztägig von Nöten ist.'
                : 'Anmerkung';
        }

        // EndDate: hide and disable for OnlineTeilnahme, otherwise show and make required
        if (endDateHolder) {
            const endInput = endDateHolder.querySelector('input');
            setFieldVisible(endDateHolder, endInput, !isOnline, !isOnline);
            // Add/remove asterisk for required field
            if (endDateLabel) {
                endDateLabel.textContent = !isOnline ? 'Bis: *' : 'Bis:';
            }
        }

        // StartDate label: "Am *" for OnlineTeilnahme, "Von *" otherwise
        if (startDateLabel) {
            startDateLabel.textContent = isOnline ? 'Am: *' : 'Von: *';
        }

        // OfficialLeaveReason: show only for Dienstbefreiung, required when visible
        setFieldVisible(getHolder(officialReasonField), officialReasonField, isDienst, isDienst);

        // OnlineParticipationReason: show only for OnlineTeilnahme, required when visible
        setFieldVisible(getHolder(onlineReasonField), onlineReasonField, isOnline, isOnline);

        // Note: not required for Urlaub or OnlineTeilnahme+familywork
        updateNoteRequired(type, onlineReasonField?.value ?? '');

        // Attachment: not required for familywork; reset when type changes
        updateAttachmentRequired(type, onlineReasonField?.value ?? '');

        // Familywork info block: shown when OnlineTeilnahme + familywork
        updateFamilyworkInfo(type, onlineReasonField?.value ?? '');

        // PDF info block in sidebar
        if (onlineInfoBlock) {
            onlineInfoBlock.style.display = isOnline ? '' : 'none';
        }

        // Sick leave hint block
        if (sickLeaveInfoBlock) {
            sickLeaveInfoBlock.style.display = isSickLeave ? '' : 'none';
        }

        // Sick leave attachment hint (below file upload)
        if (sickAttachmentHint) {
            sickAttachmentHint.style.display = isSickLeave ? '' : 'none';
        }

        // NoProctoredExam: different label for Krankmeldung
        if (noProctoredExamLabel) {
            noProctoredExamLabel.textContent = isSickLeave ? noProctoredExamSick : noProctoredExamDefault;
        }
    }

    const attachmentSubheading = attachmentCol?.querySelector('.file-section-subheading');

    function updateFamilyworkInfo(type, reason) {
        const isSpecialist = type === 'OnlineTeilnahme' && reason === 'specialist';

        if (familyworkInfoBlock) {
            familyworkInfoBlock.style.display = (type === 'OnlineTeilnahme' && reason === 'familywork') ? '' : 'none';
        }
        if (specialistInfoBlock) {
            specialistInfoBlock.style.display = isSpecialist ? '' : 'none';
        }

        // Proof of appointment booking: only for, and mandatory for, specialist appointments
        if (attachment2Col) {
            attachment2Col.style.display = isSpecialist ? '' : 'none';
        }
        if (attachment2Input) {
            attachment2Input.disabled = !isSpecialist;
            attachment2Input.required = isSpecialist;
            if (!isSpecialist) attachment2Input.value = '';
        }

        // Info-I bei "Nachweis": nur bei Facharzttermin
        if (attachmentInfoBtn) {
            attachmentInfoBtn.style.display = isSpecialist ? '' : 'none';
        }
    }

    function updateNoteRequired(type, reason) {
        if (!noteInput || !noteLabel) return;
        const isRequired = type !== 'Urlaub' && type !== 'AZV-Tage' && !(type === 'OnlineTeilnahme' && reason === 'familywork');
        noteInput.required = isRequired;
        noteLabel.textContent = isRequired ? 'Antragstext / Erläuterung *' : 'Antragstext / Erläuterung';
    }

    function updateAttachmentRequired(type, reason) {
        if (!attachmentInput) return;
        // Attachment not required for: Urlaub, AZV-Tage, Krankmeldung, or OnlineTeilnahme with familywork/specialist
        const isNotRequiredType = type === 'Urlaub' || type === 'AZV-Tage' || type === 'Krankmeldung';
        const isNotRequiredOnline = type === 'OnlineTeilnahme' && (reason === 'familywork' || reason === 'specialist');
        const isRequired = !isNotRequiredType && !isNotRequiredOnline;

        attachmentInput.required = isRequired;

        if (attachmentSubheading) {
            const isSpecialist = type === 'OnlineTeilnahme' && reason === 'specialist';
            const baseName = isSpecialist ? 'Nachweis Arztbesuch' : 'Nachweis';
            const textNode = attachmentSubheading.firstChild;
            if (textNode?.nodeType === Node.TEXT_NODE) {
                textNode.data = (isRequired ? baseName + ' *' : baseName) + ' ';
            }
        }
    }

    // Initialise on load
    updateFields(typeSelect.value);

    // Update on change
    typeSelect.addEventListener('change', function () {
        updateFields(this.value);
    });

    // Attachment required depends on online reason
    if (onlineReasonField) {
        onlineReasonField.addEventListener('change', function () {
            updateAttachmentRequired(typeSelect.value, this.value);
            updateNoteRequired(typeSelect.value, this.value);
            updateFamilyworkInfo(typeSelect.value, this.value);
        });
    }
});
